import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArrowUpRight, Calendar, MapPin } from "lucide-react";

export default function EventsSection() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => {}); }, []);
  if (events.length === 0) return null;

  return (
    <section data-testid="events-section" className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
        <div>
          <div className="overline mb-3">Join us in person</div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-tight">
            Upcoming <em className="italic text-[var(--forest)]">Events</em>
          </h2>
        </div>
        <p className="text-[var(--ink-soft)] max-w-md text-base leading-relaxed">
          Recovery happens when communities come together — with hope, real people, real support, and in nature where you can be truly grounded. Join us at the next event.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {events.map((e) => (
          <article key={e.id} data-testid={`event-${e.id}`}
            className="group relative overflow-hidden rounded-sm border border-[var(--line)] bg-[var(--bg)] hover:-translate-y-1 transition-all duration-300">
            {e.image_url && (
              <div className="aspect-[16/9] overflow-hidden">
                <img src={e.image_url} alt={e.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
            )}
            <div className="p-8">
              <div className="flex items-center gap-4 text-xs font-mono-acc text-[var(--ink-soft)] mb-3">
                {e.recurring ? (
                  <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" />Recurring</span>
                ) : e.event_date ? (
                  <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" />{e.event_date}</span>
                ) : null}
                {e.location && (
                  <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{e.location}</span>
                )}
              </div>
              <h3 className="font-serif-display text-3xl mb-3">{e.title}</h3>
              <p className="text-[var(--ink-soft)] leading-relaxed mb-5">{e.description}</p>
              {e.cta_url && (
                <a href={e.cta_url} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-[var(--forest)] hover:underline">
                  {e.cta_label || "Learn more"} <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
